import React from "react";
import { Link } from "react-router-dom";
import * as actions from '../Actions';
import Service from '../../service/Service';
const service = new Service();
import YouTube from 'react-youtube';

export default function QuickContent({ quickread, linkUrl, isDisLanding, eleRef }) {
    //console.log("QuickRead Data====>>", quickread)
    return (
        <div className="quickread-content">
            <div className="quickread-body">
                <div className="quickread-main">
                    {quickread.templateId == 0 && quickread.urls && quickread.urls.length > 0 & quickread.urls.type != 'video' &&
                        <div className="quickread-single-attachment">
                            {quickread.urls[0].source && quickread.urls[0].source != '' &&
                                <span className="discussion-single-image">
                                    <Link to={service.getRedirectUrl(linkUrl)}>
                                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={quickread.urls[0].source.replace("http://", "https://")} alt="" className="loadingImg dev_discArtImage" />
                                    </Link>
                                </span>
                            }
                        </div>
                    }
                    {quickread.templateId == 4 && quickread.urls && quickread.urls.length > 0 && quickread.urls[0].type != 'video' && quickread.urls.map((url, i) =>
                        <div key={i} className={`quickread-single-attachment temp${quickread.templateId}`}>
                            {url.source && url.source != '' &&
                                <Link to={service.getRedirectUrl(linkUrl)}>
                                    <div className={`template${quickread.templateId}`}>
                                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={url.source.replace("http://", "https://")} alt="" className="loadingImg dev_discArtImage" />
                                    </div>
                                </Link>
                            }
                        </div>
                    )}

                    {quickread.templateId != 0 && quickread.templateId != 4 && quickread.urls && quickread.urls.length > 0 && quickread.urls[0].type != 'video' &&

                        <div className="quickread-multiple-attachment">
                            {quickread.urls.length > 1 ?
                                <div className={`parenting-slider1 tmp_${quickread.templateId}`} id={`slider_${quickread.discussionId}`}>
                                    <ul className={`slider left temp${quickread.templateId}`} data-count={quickread.urls.length}>
                                        {quickread.urls.map((url, i) =>
                                            <li key={i} className={`slide left template${quickread.templateId}`}>
                                                {url.source && url.source != '' &&
                                                    <Link to={service.getRedirectUrl(linkUrl)}>
                                                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={url.source.replace("http://", "https://")} alt="" className="loadingImg" />
                                                    </Link>
                                                }
                                            </li>
                                        )}
                                    </ul>
                                    <div className="arrows">
                                        <span className="next" onClick={() => service.slideSlider('slider_' + quickread.discussionId, 300, 1000)}><span data-icon-font="h" className="icon"></span></span>
                                        <span className="prev" onClick={() => service.slideSlider('slider_' + quickread.discussionId, -300, 1000)}><span data-icon-font="g" className="icon"></span></span>
                                    </div>
                                </div>
                                :
                                <div className={`parenting-slider1 tmp_${quickread.templateId}`}>
                                    {quickread.urls[0].source && quickread.urls[0].source != '' &&
                                        <div>
                                            <Link to={service.getRedirectUrl(linkUrl)}>
                                                <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={quickread.urls[0].source.replace("http://", "https://")} alt="" className="loadingImg" />
                                            </Link>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                    <div className={`parenting-slider1 tmp_${quickread.templateId}`}>
                        {quickread.urls && quickread.urls.map((video, index) =>
                            (quickread.urls && quickread.urls[0].type == 'video' &&
                                (quickread.urls[0].source.includes("youtube") ?
                                    <div key={index} className="quickvideo_list">
                                        <div className="quickvideo_list_block" data-id={quickread.discussionId}>
                                            <Link to={service.getRedirectUrl(linkUrl)}>
                                                <YouTube videoId={quickread.urls[0].source.split('=')[1]} height={eleRef.state.videoHeight} width={eleRef.state.videoWidth} className="loadingImg" />
                                            </Link>

                                        </div>
                                    </div>
                                    :
                                    <div className="quickvideo_list" >
                                        <div className="video_block" id={quickread.discussionId}>
                                            {quickread.urls && quickread.urls[0].source &&
                                                (eleRef.state.isWindow && <div className={`videoContainer memory_video v_container_${quickread.templateId}`} data-id={`video_${quickread.discussionId}`} data-url={quickread.urls[0].source.replace("http://", "https://")} data-img={quickread.urls[0].videoThumbnaileUrl.replace("http://", "https://")}>
                                                    <div className="prism-container">
                                                        <div className="prism-player" id={`video_${quickread.discussionId}`}></div>
                                                    </div>
                                                </div>
                                                )}
                                        </div>
                                    </div>
                                )))}
                    </div>


                </div>
                <div className="quickread-summary quickreadDetails">
                    <Link to={service.getRedirectUrl(linkUrl)}>
                        <div className="quickread-title">
                            <span className="dev_quickreadTitle">{quickread.title}</span>
                        </div>
                    </Link>
                    <Link to={service.getRedirectUrl(linkUrl)}>
                        <div className="quickread-readless">
                            <span className="R14_61 quickreadDiscription dev_discussionContent discText">
                                <span id={`moretext_${quickread.discussionId}`}>{quickread.discription}</span>
                            </span>
                        </div>
                    </Link>
                    {isDisLanding &&
                        <div className="readmore_popup" data-id={`moretext_${quickread.discussionId}`}>
                            <div className="readmorequicklink R14_link" onClick={(e) => actions.readMoreClick(e, `moretext_${quickread.discussionId}`)}>Read More</div>
                        </div>
                    }

                    {quickread.urls && quickread.urls.map((url, i) =>
                        <div key={i}>
                            {url.type == 'pdf' &&
                                <div className="quickread-attachment">
                                    <span className="quickread-pdf">
                                        <a href={url.source} download>
                                            <div data-icon-font="&#xe039;" className="icon dev_quickread-pdf"></div>
                                        </a>
                                    </span>
                                </div>
                            }
                        </div>
                    )}
                    <div className="">
                        {quickread.comment && quickread.comment[0] && quickread.comment[0].comment && (isDisLanding &&
                            <Link to={service.getRedirectUrl(linkUrl)}>
                                <div className="latest-quick-comments">
                                    {quickread.comment[0].commentUserName ?
                                        <span className="M14_42 latest-comment-user">
                                            {quickread.comment[0].commentUserName}
                                        </span>
                                        :
                                        <span className="M14_42 latest-comment-user">
                                            Community User
                                </span>
                                    }
                                    {/* <span className="R14_75 latest-comment-desc" dangerouslySetInnerHTML={{ __html: actions.filterLink(discussion.comment[0].comment) }}></span> */}
                                    <span className="R14_75 latest-comment-desc">{actions.filterLink(quickread.comment[0].comment)}</span>
                                </div>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
